const ArrivalCertResponseApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/inbond-response/get`,
  POST: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/inbond-response/create`,
  PUT: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/inbond-response/update`,
  DELETE: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/inbond-response/delete`,
  EXPORT: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/inbond-response/download`
};

export default ArrivalCertResponseApiUrls
